/* Policy pages get a little Mr. DBS movie that acts the policy out.
 *   refund-policy    : busted shirt shows up, he snaps a pic, a fresh one falls from the sky
 *   privacy-policy   : thermite grenade taped to the computer. it goes off.
 *   shipping-policy  : delivery truck yeets the package, he shrugs, then points at YOU
 *   terms-of-service : he serves you a tray of ??
 * Needs dbs-walker.js (window.DBSW).
 */
(function () {
  'use strict';

  var SCENES = {
    'refund-policy':    { title: 'refund.exe',   bg: 'linear-gradient(#ff7ad9, #ffd1f2 60%, #fff)', floor: ['#7a3cff', '#5a22d6'] },
    'privacy-policy':   { title: 'privacy.exe',  bg: 'linear-gradient(#0b0b1d, #24244a 70%, #3a2a55)', floor: ['#333', '#222'] },
    'shipping-policy':  { title: 'shipping.exe', bg: 'linear-gradient(#3aa0ff, #8fd3ff 60%, #d8f3ff)', floor: ['#6b6b6b', '#585858'] },
    'terms-of-service': { title: 'terms.exe',    bg: 'linear-gradient(#ffd400, #fff3a6 65%, #fff)', floor: ['#111', '#f2f2f2'] }
  };

  function ease(t) { t = Math.max(0, Math.min(1, t)); return t * t * (3 - 2 * t); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function seg(t, a, b) { return ease((t - a) / (b - a)); }   // 0..1 progress of t through [a,b]

  function boot() {
    var box = document.querySelector('.shopify-policy__container');
    if (!box || box.querySelector('.dbspol') || !window.DBSW) return;
    var key = (location.pathname.match(/\/policies\/([^/?#]+)/) || [])[1];
    var cfg = SCENES[key];
    if (!cfg) return;
    var data = {};
    try { data = JSON.parse(document.getElementById('dbspol-data').textContent); } catch (e) {}

    var wrap = document.createElement('div');
    wrap.className = 'dbspol';
    wrap.setAttribute('data-no-chaos', '');
    wrap.innerHTML =
      '<div class="dbspol-win"><div class="dbspol-bar"><span></span><span aria-hidden="true"><i>_</i><i>&#9633;</i><i>&#215;</i></span></div>' +
      '<div class="dbspol-stage" role="img"><canvas></canvas><div class="dbspol-cap" hidden></div></div></div>';
    wrap.querySelector('.dbspol-bar span').textContent = cfg.title;
    var stage = wrap.querySelector('.dbspol-stage');
    stage.style.background = cfg.bg;
    stage.setAttribute('aria-label', 'Mr. DBS acting out the ' + key.replace(/-/g, ' '));
    var title = box.querySelector('.shopify-policy__title');
    box.insertBefore(wrap, title ? title.nextSibling : box.firstChild);

    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var W = window.DBSW, shirts = data.shirts || [];
      var it = shirts.length ? shirts[(Math.random() * shirts.length) | 0] : {};
      var ko = function (u) { return W.loadImg(u).then(function (im) { return W.knockout(im, 232); }).catch(function () { return null; }); };
      Promise.all([W.loadThree(), ko(it.f), ko(it.b), W.loadImg(data.eyes).catch(function () { return null; })])
        .then(function (r) { run(key, cfg, stage, r[0], r[1], r[2], r[3]); })
        .catch(function () { wrap.hidden = true; });
    }, { rootMargin: '150px' });
    io.observe(stage);
  }

  function run(key, cfg, stage, THREE, front, back, eyesImg) {
    var W = window.DBSW, cv = stage.querySelector('canvas'), capEl = stage.querySelector('.dbspol-cap');
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: cv, alpha: true, antialias: false }); }
    catch (e) { stage.parentNode.parentNode.hidden = true; return; }
    renderer.setPixelRatio(1);
    renderer.setClearColor(0x000000, 0);
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(30, 2, 1, 500);
    scene.add(new THREE.AmbientLight(0xffffff, 0.62));
    var sun = new THREE.DirectionalLight(0xffffff, 0.75);
    sun.position.set(-8, 20, 14);
    scene.add(sun);

    /* helpers */
    function mat(c, opts) { var m = new THREE.MeshLambertMaterial({ color: c, flatShading: true }); if (opts) for (var k in opts) m[k] = opts[k]; return m; }
    function cube(w, h, d, c, x, y, z) {
      var m = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), c && c.isMaterial ? c : mat(c));
      m.position.set(x || 0, y || 0, z || 0); return m;
    }
    function nearest(t) { t.magFilter = THREE.NearestFilter; t.minFilter = THREE.NearestFilter; return t; }
    function label(text, color, px) {
      var c = document.createElement('canvas'), x = c.getContext('2d');
      px = px || 48; x.font = 'bold ' + px + 'px Arial Black, Impact, Arial, sans-serif';
      c.width = Math.ceil(x.measureText(text).width) + 16; c.height = px + 16;
      x.font = 'bold ' + px + 'px Arial Black, Impact, Arial, sans-serif';
      x.lineWidth = px / 6; x.strokeStyle = '#000'; x.strokeText(text, 8, px);
      x.fillStyle = color; x.fillText(text, 8, px);
      var s = new THREE.Sprite(new THREE.SpriteMaterial({ map: nearest(new THREE.CanvasTexture(c)), transparent: true }));
      s.scale.set(c.width / c.height * 3, 3, 1);
      return s;
    }
    var said = '';
    function say(t) {
      if (t === said) return; said = t;
      capEl.hidden = !t; capEl.textContent = t || '';
    }

    // floor: chunky checker
    var fc = document.createElement('canvas'); fc.width = fc.height = 2;
    var fx = fc.getContext('2d'); fx.fillStyle = cfg.floor[0]; fx.fillRect(0, 0, 2, 2); fx.fillStyle = cfg.floor[1]; fx.fillRect(0, 0, 1, 1); fx.fillRect(1, 1, 1, 1);
    var ft = nearest(new THREE.CanvasTexture(fc)); ft.wrapS = ft.wrapT = THREE.RepeatWrapping; ft.repeat.set(40, 40);
    var floor = new THREE.Mesh(new THREE.PlaneGeometry(240, 240), new THREE.MeshLambertMaterial({ map: ft }));
    floor.rotation.x = -Math.PI / 2; scene.add(floor);

    /* Mr. DBS */
    var G = W.makeGuy(THREE, front, back, eyesImg);
    var guy = G.guy, hips = G.hips, head = G.head, armL = G.armL, armR = G.armR, legL = G.legL, legR = G.legR;
    scene.add(guy);
    var J = { aLs: armL.sh.rotation, aLe: armL.el.rotation, aRs: armR.sh.rotation, aRe: armR.el.rotation,
              lL: legL.hp.rotation, lLk: legL.kn.rotation, lR: legR.hp.rotation, lRk: legR.kn.rotation, hr: hips.rotation, hd: head.rotation };
    function P(o) {
      var d = { aLs: [0, 0, -0.12], aLe: [-0.15, 0, 0], aRs: [0, 0, 0.12], aRe: [-0.15, 0, 0], lL: [0, 0, 0], lLk: [0, 0, 0],
                lR: [0, 0, 0], lRk: [0, 0, 0], hr: [0, 0, 0], hd: [0, 0, 0], hy: 0 };
      for (var k in o) d[k] = o[k];
      return d;
    }
    function apply(p, k) {
      for (var key in J) { var r = J[key], v = p[key]; r.x += (v[0] - r.x) * k; r.y += (v[1] - r.y) * k; r.z += (v[2] - r.z) * k; }
      hips.position.y += (8.6 + p.hy - hips.position.y) * k;
    }
    function walkPose(ph) {   // legs only
      var s = Math.sin(ph), c = Math.cos(ph);
      legL.hp.rotation.x = 0.55 * s; legR.hp.rotation.x = -0.55 * s;
      legL.kn.rotation.x = Math.max(0, -c) * 0.9; legR.kn.rotation.x = Math.max(0, c) * 0.9;
    }
    function handAt(arm) { var o = new THREE.Object3D(); o.position.y = -3.0; arm.el.add(o); return o; }
    var handL = handAt(armL), handR = handAt(armR);
    var v1 = new THREE.Vector3(), v2 = new THREE.Vector3();
    function handsMid() { guy.updateMatrixWorld(true); handL.getWorldPosition(v1); handR.getWorldPosition(v2); return v1.add(v2).multiplyScalar(0.5); }

    /* particles (sparks, smoke, sparkles, dust) */
    var parts = [];
    function emit(n, at, o) {
      for (var i = 0; i < n; i++) {
        var m = new THREE.Mesh(new THREE.BoxGeometry(o.size, o.size, o.size),
          new THREE.MeshBasicMaterial({ color: o.colors[(Math.random() * o.colors.length) | 0], transparent: true, opacity: o.opacity || 1 }));
        m.position.set(at.x + rnd(-o.spread, o.spread), at.y + rnd(-o.spread, o.spread) * 0.5, at.z + rnd(-o.spread, o.spread));
        scene.add(m);
        parts.push({ m: m, vx: rnd(-o.v, o.v), vy: rnd(o.up[0], o.up[1]), vz: rnd(-o.v, o.v) * 0.6, life: rnd(o.life * 0.6, o.life), age: 0,
                     g: o.g == null ? -30 : o.g, grow: o.grow || 0, fade: o.fade !== false });
      }
    }
    function stepParts(dt) {
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.age += dt;
        p.vy += p.g * dt;
        p.m.position.x += p.vx * dt; p.m.position.y += p.vy * dt; p.m.position.z += p.vz * dt;
        if (p.m.position.y < 0.2) { p.m.position.y = 0.2; p.vy *= -0.3; p.vx *= 0.6; }
        if (p.grow) p.m.scale.multiplyScalar(1 + p.grow * dt);
        p.m.rotation.x += dt * 5; p.m.rotation.y += dt * 4;
        if (p.fade) p.m.material.opacity = Math.max(0, 1 - p.age / p.life);
        if (p.age >= p.life) { scene.remove(p.m); p.m.geometry.dispose(); p.m.material.dispose(); parts.splice(i, 1); }
      }
    }
    function clearParts() { parts.forEach(function (p) { scene.remove(p.m); }); parts = []; }

    /* a cardboard box with flaps that can open */
    function parcel(s) {
      var g = new THREE.Group(), card = mat(0xb07a3e), tape = mat(0xe8d39a);
      g.add(cube(4 * s, 3.2 * s, 3.2 * s, card, 0, 1.6 * s, 0));
      g.add(cube(4.05 * s, 0.5 * s, 0.6 * s, tape, 0, 3.0 * s, 0));
      var flaps = [];
      [-1, 1].forEach(function (side) {
        var hinge = new THREE.Group(); hinge.position.set(0, 3.2 * s, side * 1.6 * s); g.add(hinge);
        hinge.add(cube(4 * s, 0.15 * s, 1.6 * s, card, 0, 0.05, -side * 0.8 * s));
        hinge.userData.side = side; flaps.push(hinge);
      });
      g.userData.flaps = flaps;
      return g;
    }
    function openFlaps(p, k) { p.userData.flaps.forEach(function (h) { h.rotation.x = h.userData.side * -2.2 * k; }); }

    /* a shirt you can hold: the product photo on a card, optionally wrecked */
    function shirtCard(ko, wreck) {
      var c = W.panel(ko, 0, false), x = c.getContext('2d');
      // panel() paints a solid square; cut it to a tee shape
      var t = document.createElement('canvas'); t.width = 256; t.height = 300;
      var tx = t.getContext('2d');
      var tee = new Path2D('M70 10L186 10L250 60L215 110L196 96L196 295L60 295L60 96L41 110L6 60Z');
      tx.save(); tx.clip(tee); tx.drawImage(c, 0, 0); tx.restore();
      tx.lineWidth = 10; tx.strokeStyle = wreck ? '#ff2a2a' : '#00ff5f'; tx.stroke(tee);
      if (wreck) {
        tx.globalCompositeOperation = 'destination-out';
        for (var i = 0; i < 7; i++) { tx.beginPath(); tx.arc(rnd(70, 190), rnd(40, 280), rnd(6, 18), 0, 7); tx.fill(); }
        tx.lineWidth = 9; tx.beginPath(); tx.moveTo(196, 150); tx.lineTo(160, 190); tx.lineTo(180, 230); tx.lineTo(140, 290); tx.stroke();
        tx.globalCompositeOperation = 'source-over';
        tx.fillStyle = 'rgba(120,80,20,.65)';
        tx.beginPath(); tx.ellipse(110, 220, 34, 20, 0.4, 0, 7); tx.fill();
      }
      var m = new THREE.Mesh(new THREE.PlaneGeometry(5.2, 6.1),
        new THREE.MeshBasicMaterial({ map: nearest(new THREE.CanvasTexture(t)), transparent: true, alphaTest: 0.3, side: THREE.DoubleSide }));
      return m;
    }

    /* ---------------- the four movies ---------------- */
    var LOOP = 8, scenes = {};

    scenes['refund-policy'] = function () {
      guy.position.set(-4, 0, 0); guy.rotation.y = 0.35;
      var oldBox = parcel(1), newBox = parcel(1);
      scene.add(oldBox); scene.add(newBox);
      var bad = shirtCard(front || back, true), good = shirtCard(front || back, false);
      scene.add(bad); scene.add(good);
      var phone = cube(0.6, 1.3, 0.2, 0x111111, 0, -0.3, 0.7); handR.add(phone);
      var screenLit = cube(0.5, 1.0, 0.05, new THREE.MeshBasicMaterial({ color: 0x66ccff }), 0, 0, 0.12); phone.add(screenLit);
      var flash = 0, flashed = false;
      LOOP = 9.5;
      return function (t, dt) {
        var mid;
        // 0-1: box drops in
        var drop = seg(t, 0, 0.7);
        oldBox.visible = true;
        oldBox.position.set(3.5, lerp(28, 0, drop * drop) + (t > 0.7 && t < 1 ? Math.sin((t - 0.7) * 10) * 0.6 : 0), 3);
        oldBox.rotation.set(0, 0.3, lerp(1.2, 0, drop));
        openFlaps(oldBox, seg(t, 1.2, 1.6));
        phone.visible = t > 3.4 && t < 5;
        good.visible = t > 6.6;
        newBox.visible = t > 5.4;
        bad.visible = t > 1.5;
        if (t < 1.5) { apply(P({ hd: [0.25, -0.3, 0] }), 0.3); say(''); }
        else if (t < 2) { apply(P({ hy: -2.2, lL: [-0.8, 0, 0], lR: [-0.8, 0, 0], lLk: [1.5, 0, 0], lRk: [1.5, 0, 0], hr: [0.3, 0, 0], aLs: [-1.1, 0, -0.3], aRs: [-1.1, 0, 0.3], hd: [0.4, 0, 0] }), 0.4); }
        if (t >= 1.5 && t < 6.6) {
          if (t < 2) bad.position.set(lerp(3.5, 3.2, seg(t, 1.5, 2)), lerp(3, 7, seg(t, 1.5, 2)), 3);
          else {
            // holds the busted shirt up, shakes his head
            apply(P({ aLs: [-1.55, 0, -0.2], aRs: [-1.55, 0, 0.2], aLe: [-0.3, 0, 0], aRe: [-0.3, 0, 0], hd: [0.1, t < 3.4 ? Math.sin(t * 10) * 0.45 : 0, 0] }), 0.35);
            if (t > 3.4) apply(P({ aLs: [-1.5, 0, -0.25], aLe: [-0.3, 0, 0], aRs: [-2.1, 0, 0.5], aRe: [-0.6, 0, 0], hd: [0, 0, 0.15] }), 0.4);
            mid = handsMid();
            if (t < 3.4) bad.position.set(mid.x + 1.2, mid.y - 1.0, mid.z + 2.2);
            else if (t < 5) { handL.getWorldPosition(v1); bad.position.set(v1.x + 0.6, v1.y - 1.0, v1.z + 2.2); }
            else bad.position.y = Math.max(0.3, bad.position.y - dt * 14);   // drops it like a rag
            bad.rotation.set(t > 5 ? -1.4 : 0, 0.35, t > 5 ? 0.4 : Math.sin(t * 10) * 0.05);
            say(t < 3.4 ? 'ur shirt came in all messed up?' : t < 5 ? 'send me a pic + ur order number' : '');
          }
        }
        if (t < 1) flashed = false;
        if (t > 4.1 && !flashed) { flashed = true; flash = 0.35; }
        // replacement falls from the sky
        if (t > 5.4) {
          var d2 = seg(t, 5.4, 6.1);
          newBox.position.set(-0.5, lerp(30, 0, d2 * d2), 4); newBox.rotation.set(0, -0.4, lerp(-1, 0, d2));
          openFlaps(newBox, seg(t, 6.2, 6.6));
          if (t > 6.1 && t < 6.25) emit(3, newBox.position, { size: 0.5, colors: [0xc8a070, 0xeeeeee], spread: 2, v: 6, up: [2, 6], life: 0.8 });
        }
        if (t > 6.6) {
          apply(P({ aLs: [-2.7, 0, -0.35], aRs: [-2.7, 0, 0.35], aLe: [-0.2, 0, 0], aRe: [-0.2, 0, 0], hd: [-0.3, 0, 0], hy: Math.abs(Math.sin(t * 7)) * 0.6 }), 0.35);
          mid = handsMid();
          good.position.set(mid.x, mid.y + 2.6, mid.z + 0.6); good.rotation.set(0, 0.35, 0);
          if (Math.random() < 0.5) emit(1, { x: mid.x, y: mid.y - 1, z: mid.z + 1 }, { size: 0.45, colors: [0xffffff, 0xffd400, 0xff00e4], spread: 3, v: 3, up: [1, 4], life: 0.9, g: 0 });
          say('they just send you another :)');
        }
        if (flash > 0) { flash -= dt; stage.style.filter = 'brightness(' + (1 + flash * 6) + ')'; say('*click*'); }
        else stage.style.filter = '';
        if (t > LOOP - 0.1) { oldBox.visible = newBox.visible = good.visible = bad.visible = false; }
      };
    };

    scenes['privacy-policy'] = function () {
      guy.position.set(-6.5, 0, 0); guy.rotation.y = 1.2;
      var desk = new THREE.Group(); desk.position.set(4, 0, -1); scene.add(desk);
      var wood = mat(0x6b4423);
      desk.add(cube(11, 0.6, 5, wood, 0, 6.2, 0));
      [[-5, -2], [5, -2], [-5, 2], [5, 2]].forEach(function (p) { desk.add(cube(0.6, 6, 0.6, wood, p[0], 3, p[1])); });
      var pc = new THREE.Group(); pc.position.set(0, 6.5, -0.4); desk.add(pc);
      var beige = mat(0xd9d2b8);
      var mon = new THREE.Group(); pc.add(mon);
      mon.add(cube(5.2, 4.4, 4, beige, -1.2, 2.6, 0));
      var sc = document.createElement('canvas'); sc.width = 64; sc.height = 48;
      var sx = sc.getContext('2d');
      var scTex = nearest(new THREE.CanvasTexture(sc));
      var screen = new THREE.Mesh(new THREE.PlaneGeometry(4.2, 3.4), new THREE.MeshBasicMaterial({ map: scTex }));
      screen.position.set(-1.2, 2.7, 2.02); mon.add(screen);
      var tower = new THREE.Group(); tower.position.set(3.6, 0, 0); pc.add(tower);
      tower.add(cube(2.2, 5.4, 4.2, beige, 0, 2.7, 0));
      // the grenade, taped to the side of the tower
      var nade = new THREE.Group(); nade.position.set(0, 3.2, 2.4); tower.add(nade);
      nade.add(new THREE.Mesh(new THREE.CylinderGeometry(0.75, 0.75, 1.9, 7), mat(0x3d4a2a)));
      var lever = cube(0.25, 1.4, 0.3, 0x888888, 0.6, 0.6, 0.3); nade.add(lever);
      var ring = new THREE.Mesh(new THREE.TorusGeometry(0.35, 0.09, 4, 8), mat(0xbbbbbb)); ring.position.set(0.1, 1.25, 0.2); nade.add(ring);
      tower.add(cube(2.4, 0.4, 0.2, 0xcfcfcf, 0, 3.6, 2.15)); tower.add(cube(2.4, 0.4, 0.2, 0xcfcfcf, 0, 2.8, 2.15));
      var glow = new THREE.PointLight(0xff8a20, 0, 40); glow.position.set(7.6, 10, 3); scene.add(glow);
      var meltMats = [];
      pc.traverse(function (o) { if (o.isMesh && o.material && o.material.color && o.material !== screen.material) meltMats.push(o.material); });
      var base = meltMats.map(function (m) { return m.color.clone(); });
      var hot = new THREE.Color(0xff5a00), char = new THREE.Color(0x1a0a02);
      var lines = [], scroll = 0;
      LOOP = 9;
      return function (t, dt) {
        var alarm = t > 2.8 && t < 4.4, lit = t > 4.4;
        // the screen
        scroll += dt * 30;
        sx.fillStyle = alarm ? ((t * 6 | 0) % 2 ? '#ff0000' : '#330000') : '#001a00';
        sx.fillRect(0, 0, 64, 48);
        sx.fillStyle = alarm ? '#fff' : '#33ff66';
        sx.font = 'bold 8px monospace';
        if (alarm) { sx.fillText('BREACH', 8, 22); sx.fillText('DETECTED', 4, 34); }
        else if (!lit) for (var i = 0; i < 6; i++) sx.fillText(((scroll / 8 + i) | 0).toString(2).slice(-8), 2, 8 + i * 8 - (scroll % 8));
        scTex.needsUpdate = true;
        screen.visible = !lit || t < 5.4;

        if (t < 2.8) {
          // typing away
          guy.rotation.y = 1.2;
          apply(P({ aLs: [-1.25, 0, -0.1], aRs: [-1.25 + Math.sin(t * 22) * 0.12, 0, 0.1], aLe: [-0.35 + Math.cos(t * 19) * 0.12, 0, 0], aRe: [-0.35, 0, 0], hd: [0.15, 0, 0] }), 0.5);
          say('ur data stays on my computer');
        } else if (t < 3.5) {
          // BREACH: freak out at the camera
          guy.rotation.y = lerp(1.2, 0.2, seg(t, 2.8, 3.1));
          apply(P({ aLs: [-0.3, 0, -2.6], aRs: [-0.3, 0, 2.6], hd: [-0.25, 0, 0], hy: 0.4 }), 0.6);
          say('COMPROMISED??');
        } else if (t < 4.4) {
          // pulls the pin
          guy.rotation.y = lerp(0.2, 1.3, seg(t, 3.5, 3.8));
          apply(P({ aRs: [-1.4, 0, 0.25], aRe: [-0.2, 0, 0], hd: [0.2, 0, 0] }), 0.5);
          if (t > 4.0) { ring.position.x = 0.1 + (t - 4) * 8; ring.position.y = 1.25 + (t - 4) * 4; lever.rotation.z = -(t - 4) * 4; }
          say('thermite time');
        } else {
          // it burns. he steps back and gives a thumbs up
          guy.rotation.y = lerp(1.3, 0.25, seg(t, 4.4, 4.8));
          guy.position.x = lerp(-6.5, -9.5, seg(t, 4.4, 4.9));
          var thumbs = t > 6;
          apply(P({ aLs: [-0.2, 0, -0.4], aLe: [-0.3, 0, 0], aRs: thumbs ? [-0.4, 0, 1.0] : [-0.2, 0, 0.4], aRe: thumbs ? [0, 0, 1.6] : [-0.3, 0, 0], hd: [0, -0.6 + (thumbs ? 0.6 : 0), 0] }), 0.4);
          var b = seg(t, 4.4, 7.0);
          pc.scale.set(1 + b * 0.25, 1 - b * 0.82, 1 + b * 0.2);
          meltMats.forEach(function (m, n) { m.color.copy(base[n]).lerp(hot, Math.min(1, b * 2.2)).lerp(char, Math.max(0, b * 1.6 - 0.6)); });
          glow.intensity = (1 - seg(t, 6.5, 8.2)) * (2 + Math.random() * 2.5);
          if (t < 7.2) {
            emit(5, { x: 7.6, y: 8.5 + 3.2 * (1 - b), z: 1.5 }, { size: 0.35, colors: [0xffffff, 0xfff27a, 0xffa020], spread: 0.6, v: 9, up: [6, 16], life: 0.7 });
            if (Math.random() < 0.6) emit(1, { x: 6, y: 10, z: 0 }, { size: 1.6, colors: [0x555555, 0x777777, 0x333333], spread: 2, v: 1.2, up: [3, 6], life: 2.2, g: 0, grow: 0.8, opacity: 0.8 });
          }
          say(thumbs ? 'nobody is getting ur data lol' : 'hard drives: gone');
        }
        if (t > LOOP - 0.12) {
          pc.scale.set(1, 1, 1); meltMats.forEach(function (m, n) { m.color.copy(base[n]); });
          ring.position.set(0.1, 1.25, 0.2); lever.rotation.z = 0; guy.position.x = -6.5; glow.intensity = 0;
        }
      };
    };

    scenes['shipping-policy'] = function () {
      guy.position.set(9, 0, 1); guy.rotation.y = -0.6;
      // road stripe
      for (var i = -6; i <= 6; i++) scene.add(cube(4, 0.05, 0.5, 0xffd400, i * 9, 0.03, -7));
      var truck = new THREE.Group(); scene.add(truck);
      truck.add(cube(13, 7, 6, 0xf2f2f2, 0, 4.8, 0));
      truck.add(cube(4.5, 5, 6, 0x2a62ff, 8.6, 3.8, 0));
      var glass = cube(0.2, 2, 5, new THREE.MeshBasicMaterial({ color: 0x9fe3ff }), 10.9, 5, 0); truck.add(glass);
      var side = label('SHIPPING CO.', '#ff00e4', 40); side.position.set(0, 5.2, 3.2); side.scale.multiplyScalar(1.6); truck.add(side);
      [[-4, 1], [-4, -1], [7.5, 1], [7.5, -1]].forEach(function (p) {
        var w = new THREE.Mesh(new THREE.CylinderGeometry(1.2, 1.2, 0.8, 8), mat(0x111111));
        w.rotation.x = Math.PI / 2; w.position.set(p[0], 1.2, p[1] * 3.1); truck.add(w);
      });
      truck.position.z = -9;
      var pkg = parcel(0.9); scene.add(pkg);
      var st = { x: 0, y: 0, z: 0, vx: 0, vy: 0, vz: 0, spin: 0, landed: false };
      LOOP = 8.5;
      return function (t, dt) {
        truck.position.x = lerp(-70, 80, Math.min(1, t / 2.4));
        truck.visible = t < 2.6;
        if (t < 0.9) { pkg.position.set(truck.position.x - 4, 8.4, -9); pkg.rotation.set(0, 0, 0); pkg.scale.set(1, 1, 1); st.landed = false; }
        else {
          if (st.vx === 0 && !st.landed) { st.x = pkg.position.x; st.y = pkg.position.y; st.z = -9; st.vx = 9; st.vy = 12; st.vz = 9; st.spin = 9; }
          if (!st.landed) {
            st.vy -= 40 * dt; st.x += st.vx * dt; st.y += st.vy * dt; st.z += st.vz * dt;
            pkg.rotation.z -= st.spin * dt; pkg.rotation.x += st.spin * 0.5 * dt;
            if (st.y <= 0 && st.vy < 0) {
              if (Math.abs(st.vy) > 8) { st.vy = -st.vy * 0.35; st.vx *= 0.5; st.vz *= 0.4; st.spin *= 0.5; emit(6, { x: st.x, y: 0.5, z: st.z }, { size: 0.6, colors: [0xbfae90, 0x9a8a70], spread: 1.5, v: 4, up: [2, 5], life: 0.7 }); }
              else { st.y = 0; st.landed = true; pkg.rotation.set(0, 0.4, 0.3); }
            }
            pkg.position.set(st.x, Math.max(0, st.y), st.z);
          } else {
            // squish
            var sq = seg(t, 2.2, 2.4);
            pkg.scale.set(1 + sq * 0.35, 1 - sq * 0.55, 1 + sq * 0.25);
          }
        }
        if (t < 2.4) { apply(P({ hd: [0, -0.5, 0] }), 0.3); say(''); }
        else if (t < 3.6) {
          guy.rotation.y = lerp(-0.6, -0.9, seg(t, 2.4, 2.8));
          apply(P({ hd: [0.35, 0, 0] }), 0.3); say('ur package got messed up?');
        } else if (t < 5.4) {
          guy.rotation.y = lerp(-0.9, 0, seg(t, 3.6, 3.9));
          apply(P({ aLs: [-0.35, 0, -0.55], aRs: [-0.35, 0, 0.55], aLe: [-1.2, 0, 0], aRe: [-1.2, 0, 0], hd: [0, 0, 0.3], hy: 0.25 }), 0.4);
          say('idk dude probably not my fault');
        } else {
          guy.rotation.y = 0;
          apply(P({ aRs: [-1.55, 0, 0.05], aRe: [0, 0, 0], aLs: [0, 0, -0.75], aLe: [0, 0, 1.9], hd: [-0.15, 0, 0] }), 0.5);
          say('YOU did somthing');
        }
        if (t > LOOP - 0.12) { st.vx = 0; st.landed = false; pkg.scale.set(1, 1, 1); }
      };
    };

    scenes['terms-of-service'] = function () {
      guy.position.set(-1.5, 0, 0); guy.rotation.y = 0.45;
      var silver = mat(0xd8dde4), napkin = mat(0xffffff);
      // the tray sits on his right hand, waiter style
      var trayHold = new THREE.Group(); handR.add(trayHold);
      var tray = new THREE.Mesh(new THREE.CylinderGeometry(3.2, 3.2, 0.25, 10), silver);
      trayHold.add(tray);
      var cloche = new THREE.Group(); trayHold.add(cloche);
      var dome = new THREE.Mesh(new THREE.SphereGeometry(2.6, 8, 4, 0, Math.PI * 2, 0, Math.PI / 2), silver); cloche.add(dome);
      cloche.add(cube(0.5, 0.5, 0.5, silver, 0, 2.8, 0));
      // napkin over his other arm
      var nap = cube(1.5, 2.6, 1.5, napkin, 0, -1.6, 0); armL.el.add(nap);
      var qs = [];
      LOOP = 7;
      return function (t, dt) {
        // forearm forward, palm up, tray level
        apply(P({ aRs: [-0.25, 0, 0.35], aRe: [-1.45, 0, -0.35], aLs: [-0.5, 0, -0.15], aLe: [-1.5, 0, 0.2],
                  hr: [t > 1 && t < 2 ? 0.45 * Math.sin(seg(t, 1, 2) * Math.PI) : 0, 0, 0],
                  hd: [0, 0, t > 3 ? Math.sin(t * 2) * 0.35 : 0] }), 0.35);
        trayHold.rotation.set(1.7, 0, 0);
        trayHold.position.set(0, 0.2, -0.9);
        var lift = seg(t, 2.2, 2.7);
        cloche.position.y = 0.1 + lift * 4.5; cloche.rotation.z = lift * 0.6; cloche.visible = t < 3.6;
        if (t > 2.6 && t < 6 && (qs.length < 6) && Math.random() < 0.18) {
          var q = label('??', ['#ff00e4', '#00d4ff', '#00ff5f', '#ffd400'][(Math.random() * 4) | 0], 56);
          trayHold.getWorldPosition(v1);
          q.position.set(v1.x + rnd(-1, 1), v1.y + 1.5, v1.z + 1); q.userData = { vx: rnd(-3, 3), vy: rnd(3, 6), age: 0 };
          scene.add(q); qs.push(q);
        }
        for (var i = qs.length - 1; i >= 0; i--) {
          var s = qs[i]; s.userData.age += dt;
          s.position.x += s.userData.vx * dt; s.position.y += s.userData.vy * dt;
          s.material.rotation = Math.sin(s.userData.age * 6) * 0.3;
          if (s.userData.age > 2.6 || t > LOOP - 0.12) { scene.remove(s); qs.splice(i, 1); }
        }
        say(t < 1 ? '' : t < 2.2 ? 'my service' : t < 4.5 ? 'is your term' : '??');
      };
    };

    var update = scenes[key]();

    /* sizing / camera */
    var PIX = 3;
    function resize() {
      var w = Math.max(80, stage.clientWidth), h = Math.max(80, stage.clientHeight);
      renderer.setSize(Math.ceil(w / PIX), Math.ceil(h / PIX), false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      var tanH = Math.tan(THREE.MathUtils.degToRad(15));
      var dist = Math.max(15 / tanH, (key === 'shipping-policy' ? 26 : 19) / (tanH * camera.aspect));
      camera.position.set(0, 13, dist);
      camera.lookAt(0, 9.5, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    var visible = true, last = 0, acc = 0, T = 0;
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(stage);
    function tick(now) {
      requestAnimationFrame(tick);
      if (!visible || document.hidden) { last = now; return; }
      var dt = Math.min(0.1, (now - (last || now)) / 1000); last = now;
      acc += dt;
      if (acc < 1 / 12) return;   // 12 fps
      var step = Math.min(acc, 0.12); acc = 0;
      T += step;
      if (T >= LOOP) { T = 0; clearParts(); }
      update(T, step);
      stepParts(step);
      renderer.render(scene, camera);
    }
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
